export const setNullToUndefined = (formData) => {
    if (formData) {
        Object.keys(formData).forEach((val) => {
            if (formData[val] === null) {
                formData[val] = undefined;
            }
        });
    }
};

export const setPersonTobaccoFields = (person, schema, uiSchema) => {
    if (person) {
        // current tobacco user?
        if (person.isCurrentSmoker) {
            // current tobacco user, null and disable previous tobacco questions

            // null previous tobacco fields
            person.isPreviousSmoker = undefined;
            person.previousSmokerQuitDate = undefined;

            // disable previous tobacco fields
            uiSchema.isPreviousSmoker = {
                "ui:widget": "radio",
                "ui:disabled": true
            };
            uiSchema.previousSmokerQuitDate = {
                "ui:disabled": true
            };

            // remove previous tobacco fields from required fields
            let filtered = schema.required.filter(function (value, index, arr) {
                return value !== 'isPreviousSmoker' && value !== 'previousSmokerQuitDate';
            });
            schema.required = filtered;
        }
        else {
            // not a current tobacco user

            // enable previous tobacco fields
            uiSchema.isPreviousSmoker = {
                "ui:widget": "radio",
                "ui:disabled": false
            };

            // add isPreviousSmoker to required fields
            if (!schema.required.includes('isPreviousSmoker')) {
                schema.required = schema.required.concat('isPreviousSmoker');
            }

            // previous tobacco user?
            if (person.isPreviousSmoker) {

                // enable previousSmokerQuitDate
                uiSchema.previousSmokerQuitDate = {
                    "ui:widget": "customDate",
                    "ui:disabled": false
                };

                // add previousSmokerQuitDate to required fields
                if (!schema.required.includes('previousSmokerQuitDate')) {
                    schema.required = schema.required.concat('previousSmokerQuitDate');
                }
            }
            else {
                // not a previous tobacco user

                // null previousSmokerQuitDate field
                person.previousSmokerQuitDate = undefined;

                // disable previousSmokerQuitDate
                uiSchema.previousSmokerQuitDate = {
                    "ui:disabled": true
                };

                // remove previousSmokerQuitDate from required fields
                let filtered = schema.required.filter(function (value, index, arr) {
                    return value !== 'previousSmokerQuitDate';
                });
                schema.required = filtered;
            }
        }
    }
};

export const validateDates = (datesToVerify, formData, schema) => {
    let valid = true;

    datesToVerify.forEach(date => {
        const dateValue = formData[date];
        const dateValueIsValid = dateValue && dateValue !== "thisisanerror";
        if (dateValueIsValid) {
            const d = new Date(dateValue);
            if (!(d instanceof Date && isFinite(d))) {
                valid = false;
                return;
            }
        } else {
            if (dateValue === "thisisanerror") {
                valid = false;
                return;
            }
            if (!dateValue && schema.required.indexOf(date) > -1) {
                valid = false;
                return;
            }
        }
    });

    if (!valid) {
        alert('Invalid date entry detected. Date format must be MM/DD/YYYY. Please correct before saving.');
    }

    return valid;
};